import Request from '../request'

// types
import type { SenderIDFetchResponse } from '../../types/api/responses/senderIds'
import type { AxiosResponseType } from '../../types/api/responses/common'

type Params = {
	is_survey?: boolean
	page?: number
	per?: number
}
export function getAccountSenderIds({
	accountId,
	params,
}: {
	accountId: number
	params?: Params
}): Promise<AxiosResponseType<SenderIDFetchResponse>> {
	return Request.get({
		url: `/accounts/${accountId}/sender_ids`,
		params,
	})
}
